import React, { Component } from "react";
import { connect } from "react-redux";

import {
  showModal,
  setLevel,
  undo,
} from '@learningblocks/protocol-redux/lib/Actions';

import "./Undo.scss";
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";
import undoIcon from "./img/undo-modal-icon.svg";
import {LogEvent} from '@learningblocks/shared-components/lib/EventLogger'; 

class Undo extends Component {

  noClicked = () => {
    this.props.showModal({display: false});
  };

  yesClicked = () => {
    if (this.props.restarts > 0 && Object.keys(this.props.snapshots).length > 0) {

      if(this.props.snapshots.hasOwnProperty('back2')){
        this.props.undo({
          lastState: this.props.snapshots.back2
        });
      } else {
        this.props.undo({
          lastState: this.props.snapshots.back1
        });
      }
    } else {
      console.log("WARNING: No more undo attempts left.");
    }

    this.props.showModal({display: false});
  };

  renderTaskIndex = () => {
    return this.props.page + "." + String.fromCharCode(97 + this.props.task.index)
  }

  render() {
    return (
      <div className="modal-section undo">
        <img alt="Undo Icon" src={undoIcon} className="undoModalIcon" />

        <h4 className="restartModalHeading">
          Are you sure you want to undo this step?
        </h4>

        {/* <p className="taskText">{this.renderTaskIndex()} {this.props.task.levels["l"+this.props.level].task}</p> */}

        <p className="restartsLeftText">{this.props.restarts} restarts left</p>

        <div className="modal-footer">

        <LogEvent
            logEventProps={{
              event_type: "sim_protocol_undo rejected",
              event_schema: "track",
              success: false
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              aria-label="No"
              tabIndex={this.props.tab}
              className="modal-btn-secondary lvl-choice"
              onClick={this.noClicked}
            >
              No
            </button>
          </LogEvent>
          <LogEvent
            logEventProps={{
              event_type: "sim_protocol_undo accepted",
              event_schema: "track",
              success: true
            }}
            actionProps={{ onClick: { action: 'click' } }}
            elementType="button"
          >
            <button
              aria-label="Yes"
              tabIndex={this.props.tab}
              className="modal-btn-primary lvl-choice"
              onClick={this.yesClicked}
            >
              Yes
            </button>
          </LogEvent>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    task: state.notebook.protocolSection.scene.focusedTaskObj,
    restarts: state.notebook.protocolSection.scene.undo?.attempts,
    level: state.notebook.protocolSection.scene.level,
    page: state.notebook.protocolSection.scene.currentProtocolPage,
    lastState: state.notebook.protocolSection.scene.undo?.snapshots.back1,
    snapshots: state.notebook.protocolSection.scene.undo?.snapshots,
  };
};

export default connect(
  mapStateToProps,
  {
    setLevel,
    showModal,
    undo,
  }
)(Undo);
